/**
 * Toast 轻提示组件
 */

import React, { useEffect, useState, useCallback } from 'react';
import styles from './Toast.module.css';

let toast_fn = null;

export function toast(message, type = 'info', duration = 3000) {
  if (toast_fn) {
    toast_fn({ message, type, duration });
  }
}

toast.success = (msg, duration) => toast(msg, 'success', duration);
toast.error = (msg, duration) => toast(msg, 'error', duration);
toast.warning = (msg, duration) => toast(msg, 'warning', duration);
toast.info = (msg, duration) => toast(msg, 'info', duration);

export function ToastProvider() {
  const [toasts, set_toasts] = useState([]);

  const add_toast = useCallback(({ message, type, duration }) => {
    const id = Date.now() + Math.random();
    set_toasts(prev => [...prev, { id, message, type, duration, visible: true }]);
    setTimeout(() => {
      set_toasts(prev => prev.filter(t => t.id !== id));
    }, duration || 3000);
  }, []);

  useEffect(() => {
    toast_fn = add_toast;
    return () => { toast_fn = null; };
  }, [add_toast]);

  return (
    <div className={styles.container}>
      {toasts.map(t => (
        <div key={t.id} className={`${styles.toast} ${styles[t.type]}`}>
          <span className={styles.icon}>{get_icon(t.type)}</span>
          <span className={styles.message}>{t.message}</span>
        </div>
      ))}
    </div>
  );
}

function get_icon(type) {
  const icons = { success: '✓', error: '✕', warning: '⚠', info: 'ℹ' };
  return icons[type] || icons.info;
}
